<template>
  <div>
    <div class="flex flex-col md:flex-row items-start md:items-center justify-between w-full mb-4 space-y-2 md:space-y-0 md:space-x-2">
      <div class="relative font-manrope w-full md:w-1/2">
        <span class="absolute text-gray-600 top-2.5 left-0 flex items-center pl-4">
          <button type="submit" class="focus:outline-none focus:shadow-outline focus-within:text-primary -mb-0.5" aria-label="Search">
            <i class="fa-solid fa-magnifying-glass"></i>
          </button>
        </span>
        <input
          v-model="searchStudents"
          aria-autocomplete="none"
          type="text"
          class="py-2 w-full text-sm text-gray-700 pl-10 pr-4 border border-gray-200 rounded outline-none ring-offset-1 focus:ring-2 focus:ring-primary transition"
          placeholder="Search..."
          autocomplete="off"
        />
      </div>
      <div class="flex flex-col sm:flex-row items-stretch sm:items-center w-full md:w-auto space-y-2 sm:space-y-0 sm:space-x-2">
        <label
          for="fileUpload"
          v-if="studentsSelectedToDelete.length === 0"
          class="cursor-pointer flex-1 sm:flex-none flex justify-center items-center space-x-2 px-5 py-2 bg-gray-800 hover:bg-gray-900 text-white rounded font-manrope transition"
        >
          <span>{{ isAddingStudents ? 'Importing...' : 'Import' }}</span>
          <div v-if="isAddingStudents" class="loader"></div>
        </label>
        <input
          id="fileUpload"
          ref="fileToUpload"
          type="file"
          accept=".csv"
          class="hidden"
          @change="selectFileToUpload"
          :disabled="$route.params.courseID === $store.state.course_sample_id"
        />
        <button
          v-if="studentsSelectedToDelete.length > 0"
          @click="isModalDeleteParticipantsOpen = true"
          :disabled="studentsSelectedToDelete.length === 0"
          class="flex-1 sm:flex-none flex justify-center items-center px-5 py-2 bg-red-500 hover:bg-red-600 disabled:bg-red-300 text-white rounded font-manrope transition"
        >
          Remove ({{ studentsSelectedToDelete.length }})
        </button>
      </div>
    </div>
    <div class="flex flex-col">
      <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full sm:px-6 lg:px-8">
          <div v-if="studentsFiltered.length === 0" class="px-4">
            <span class="text-gray-400">No students found.</span>
          </div>
          <div v-else class="overflow-hidden rounded">
            <table class="min-w-full border rounded">
              <thead class="border-b font-manrope text-gray-700 font-normal">
                <tr>
                  <th scope="col" class="w-10 text-sm px-6 py-2.5 text-left">
                    <input class="cursor-pointer" type="checkbox" @click="selectAllStudents($event)" v-model="isAllSelected" />
                  </th>
                  <th scope="col" class="w-4/12 px-4 py-2.5 text-left">
                    Full Name
                    <button @click="sortByStudentName()">
                      <i class="ml-2 fa" :class="!isOrdering ? 'fa-angle-down' : 'fa-angle-up'"></i>
                    </button>
                  </th>
                  <th scope="col" class="w-5/12 px-6 py-2.5 text-left">
                    E-mail
                  </th>
                  <th scope="col" class="w-1/6 px-6 py-2.5 text-left">
                    RoundTables
                    <button @click="sortByNumberOfRoundTables()">
                      <i class="ml-2 fa " :class="!isOrderingByRTs ? 'fa-angle-down': 'fa-angle-up'"></i>
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="border-b hover:bg-gray-50 font-manrope" v-for="(student, index) in studentsFiltered" :key="index">
                  <td class="py-2.5 px-6">
                    <input class="cursor-pointer" v-if="!student.subscription.created_from_clever" v-model="selectedStudents[index]" @change="handleSelectStudents(), updateCheckAll()" type="checkbox" />
                  </td>
                  <td class="pt-3 px-4 flex items-center">
                    <img :src="student.avatar_url" class="rounded-full h-6 w-6 mr-3" />
                    <div class="flex items-center cursor-pointer">
                      <span @click="viewStudentReport(student.id)" class="hover:underline">{{ student.name }}</span>
                      <span v-if="student.pending" class="text-primary ml-0.5">(Pending)</span>
                    </div>
                  </td>
                  <td class="py-2.5 px-6">
                    <a class="text-gray-600 hover:underline" :href="'mailto:' + student.email">{{ student.email }}</a>
                  </td>
                  <td class="py-2.5 px-6">
                    <span class="text-center ml-10">{{ sumOfRoundTables(student.rts_count, student.lives_count) }}</span>
                  </td>
                 
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <DeleteDialog
      v-if="isModalDeleteParticipantsOpen"
      :message="'Remove Students ' + '(' + studentsSelectedToDelete.length + ')'"
      :confirmColor="'bg-red-500 hover:bg-red-600'"
      :confirmText="'DELETE'"
      :typeConfirm="false"
      @close="isModalDeleteParticipantsOpen = false"
      @confirm="deleteSelectedStudents()"
    >
      <div class="text-center text-gray-700 my-10">
        <i class="fa-solid fa-circle-exclamation text-red-500 text-4xl mb-5"></i>
        <p class="text-center mx-12">
          Are you sure you want to remove this students
          <span class="font-bold"></span> from the course? This action is
          irreversible and students will lose all their activity.
        </p>
      </div>
    </DeleteDialog>
  </div>
  <!-- <div>
    <div class="flex flex-col md:flex-row md:justify-between">
      <div class="relative font-manrope">
        <span class="absolute text-gray-400 top-2.5 left-0 flex items-center pl-3">
          <button type="submit" class="px-1 focus:outline-none focus:shadow-outline">
            <i class="fa-solid fa-magnifying-glass"></i>
          </button>
        </span>
        <input v-model="searchStudents" aria-autocomplete="none" type="text" class="py-2 w-full text-sm text-gray-700 pl-10 pr-4 border border-solid border-gray-200 rounded-md outline-none" placeholder="Search..." autocomplete="off" />
      </div>
      <div class="flex flex-col mt-2 md:mt-0">
        <div class="flex items-center space-x-2">
          <button class="sample space-x-2 px-5 py-2 bg-primary hover:bg-primary-dark text-white rounded flex items-center font-manrope">
            <label for="fileUpload" class="cursor-pointer">
              {{ isAddingStudents ? 'Adding Students...' : 'Add Students' }}
            </label>
            <div v-if="isAddingStudents" class="loader"></div>
          </button>
          <input id="fileUpload" ref="fileToUpload" type="file" accept=".csv" class="hidden" @change="selectFileToUpload" :disabled="$route.params.courseID === $store.state.course_sample_id" />
          <button
            v-if="studentsSelectedToDelete.length > 0"
            :disabled="studentsSelectedToDelete.length === 0 ? true : false"
            @click="isModalDeleteParticipantsOpen = true"
            class="sample px-5 py-2 text-white rounded flex items-center font-manrope bg-red-500 hover:bg-red-600 disabled:bg-red-300"
          >
            Remove ({{ studentsSelectedToDelete.length }})
          </button>
        </div>
        <div class="w-full">
          <a href="../../../../static/upload_csv_files/users_course.csv" target="_blank" download="users_course.csv" class="underline text-blue-700 hover:text-blue-900 text-xs">
            CSV Template
          </a>
        </div>
      </div>
    </div>
    <div class="flex flex-col">
      <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full sm:px-6 lg:px-8">
          <div v-if="studentsFiltered.length === 0" class="px-4">
            <span class="text-gray-400">No students found.</span>
          </div>
          <div v-else class="overflow-hidden rounded">
            <table class="min-w-full border">
              <thead class="border-b font-manrope text-gray-700 font-normal">
                <tr>
                  <th scope="col" class="w-10 text-sm px-6 py-2.5 text-left">
                    <input type="checkbox" @click="selectAllStudents($event)" v-model="isAllSelected" />
                  </th>
                  <th scope="col" class="w-4/12 px-4 py-2.5 text-left">
                    Full Name
                    <button @click="sortByStudentName()">
                      <i class="ml-2 fa" :class="!isOrdering ? 'fa-angle-down' : 'fa-angle-up'"></i>
                    </button>
                  </th>
                  <th scope="col" class="w-5/12 px-6 py-2.5 text-left">
                    E-mail
                  </th>
                  <th scope="col" class="w-1/6 px-6 py-2.5 text-left">
                    RoundTables
                    <button @click="sortByNumberOfRoundTables()">
                      <i class="ml-2 fa " :class="!isOrderingByRTs ? 'fa-angle-down': 'fa-angle-up'"></i>
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="border-b hover:bg-gray-50 font-manrope" v-for="(student, index) in studentsFiltered" :key="index">
                  <td class="py-2.5 px-6">
                    <input v-if="!student.subscription.created_from_clever" v-model="selectedStudents[index]" @change="handleSelectStudents(), updateCheckAll()" type="checkbox" />
                  </td>
                  <td class="pt-3 px-4 flex items-center">
                    <img :src="student.avatar_url" class="rounded-full h-6 w-6 mr-3" />
                    <div class="flex items-center cursor-pointer">
                      <span @click="viewStudentReport(student.id)" class="hover:underline">{{ student.name }}</span>
                      <span v-if="student.pending" class="text-primary ml-0.5">(Pending)</span>
                    </div>
                  </td>
                  <td class="py-2.5 px-6">
                    <a class="text-gray-600 hover:underline" :href="'mailto:' + student.email">{{ student.email }}</a>
                  </td>
                  <td class="py-2.5 px-6">
                    <span class="text-center ml-10">{{ sumOfRoundTables(student.rts_count, student.lives_count) }}</span>
                  </td>
                 
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <DeleteDialog
      v-if="isModalDeleteParticipantsOpen"
      :message="'Remove Students ' + '(' + studentsSelectedToDelete.length + ')'"
      :confirmColor="'bg-red-500 hover:bg-red-600'"
      :confirmText="'DELETE'"
      :typeConfirm="false"
      @close="isModalDeleteParticipantsOpen = false"
      @confirm="deleteSelectedStudents()"
    >
      <div class="text-center text-gray-700 my-10">
        <i class="fa-solid fa-circle-exclamation text-red-500 text-4xl mb-5"></i>
        <p class="text-center mx-12">
          Are you sure you want to remove this students
          <span class="font-bold"></span> from the course? This action is
          irreversible and students will lose all their activity.
        </p>
      </div>
    </DeleteDialog>
  </div> -->
</template>
<script>
  import Vue from 'vue';
  import store from 'store';
  import courses_service from 'services/courses';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';

  export default Vue.extend({
    data() {
      return {
        selectedStudents: [],
        isAllSelected: false,
        isModalDeleteParticipantsOpen: false,
        searchStudents: '',
        isOrdering: false,
        isOrderingByRTs: false,
        student_object: {
          name: '',
          email: '',
        },
        isAddingStudents: false,
      };
    },
    components: {
      DeleteDialog: () => import( '../../../../../app/components/material/components/plDialog/plDialogConfirm.vue'),
    },
    computed: {
      ...mapGetters(['getProfile', 'getStudentsInCourse']),
      studentsSelectedToDelete: function () {
        const selectedStudents = this.selectedStudents.map((status, index) => (status ? index : false)).filter((status) => typeof status === 'number');
        const studentsToDelete = this.studentsFiltered.filter((student, index) => selectedStudents.includes(index)).map((student) => student.id);
        return studentsToDelete;
      },
      studentsFiltered: function () {
        let filtered = this.getStudentsInCourse;
        if (!this.searchStudents) return filtered;
        filtered = this.getStudentsInCourse.filter((student) => {
          if (student.name)
            return student.name.toLowerCase().includes(this.searchStudents.toLowerCase());
        });
        return filtered;
      },
    },
    methods: {
      handleSelectStudents: function (event, index) {
        let status = [...this.selectedStudents];
        status[index] = event;
        this.selectedStudents = status;
        this.$emit('selectedStudents', this.studentsSelectedToDelete);
      },
      sortByNumberOfRoundTables: function () {
        if (this.isOrderingByRTs === true) {
          this.studentsFiltered.sort((a, b) => {
            const _a = this.sumOfRoundTables(a.rts_count, a.lives_count);
            const _b = this.sumOfRoundTables(b.rts_count, b.lives_count);
            return _b.toString().localeCompare(_a.toString());
          });
        } else {
          this.studentsFiltered.sort((a, b) => {
            const _a = this.sumOfRoundTables(a.rts_count, a.lives_count);
            const _b = this.sumOfRoundTables(b.rts_count, b.lives_count);
            return _a.toString().localeCompare(_b.toString());
          });
        }
        this.isOrderingByRTs = !this.isOrderingByRTs;
        this.isOrdering = false;
      },
      sortByStudentName: function () {
        if (this.isOrdering === true) {
          this.studentsFiltered.sort((a, b) => {
            return b.name.localeCompare(a.name);
          });
        } else {
          this.studentsFiltered.sort((a, b) => {
            return a.name.localeCompare(b.name);
          });
        }
        this.isOrdering = !this.isOrdering;
        this.isOrderingByRTs = false;
      },
      updateCheckAll: function () {
        if (this.getStudentsInCourse.length === this.studentsSelectedToDelete.length) {
          this.isAllSelected = true;
        }
        else this.isAllSelected = false;
      },
      selectAllStudents: function (event) {
        this.isAllSelected = !this.isAllSelected;
        this.selectedStudents = [];
        if (!this.isAllSelected) {
          return this.$emit('selectedStudents', this.studentsSelectedToDelete);
        }
        this.selectedStudents = this.getStudentsInCourse.map((student) => {
          return student.subscription.created_from_clever ? false : event;
        });
        this.$emit('selectedStudents', this.studentsSelectedToDelete);
      },
      deleteSelectedStudents: function () {
        const students = { student_ids: this.studentsSelectedToDelete };
        courses_service.removeStudents(this.$route.params.courseID, students).then((res) => {
          const deletedArray = res.data.removed;
          store.dispatch('removeStudents', deletedArray);
          this.selectedStudents = [];
          this.isAllSelected = false;
        }).catch((error) => {
          console.error(error);
        });
      },
      sumOfRoundTables: function (online, live) {
        const total = parseInt(online) + parseInt(live);
        return total;
      },
      viewStudentReport: function (studentId) {
        if (!this.getProfile.is_paid) {
          const text ='student reports and data export feature for all your classes.';
          const studentReport = true;
          EventBus.$emit('open-upgrade-modal', text, studentReport);
          return;
        }
        this.$router.push({
          name: 'course.student-reports.summary',
          params: { studentID: studentId },
          query: { student: true },
        });
      },
      selectFileToUpload() {
        let input = document.getElementById('fileUpload');
        let files = input.files;
        if (!files.length) return;
        const file = files[0];
        if (file.type !== 'text/csv') {
          const toast = {
            type: 'Error',
            message: 'Invalid file type. (Accepted .csv)',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
          return;
        }
        let reader = new FileReader();
        reader.onload = (e) => {
          const file = e.target.result;
          let lines = file.split(/r\n|\n/);
          lines = lines.filter((l) => !!l);
          this.handleAddCSVStudents(lines);
        };
        reader.readAsText(file, 'ISO-8859-1');
      },
      arraysEqual: function (a, b) {
        if (a === b) return true;
        if (a == null || b == null) return false;
        if (a.length !== b.length) return false;
        for (var i = 0; i < a.length; ++i) {
          if (a[i].trim() !== b[i].trim()) return false;
        }
        return true;
      },
      isAnEmail(email) {
        var regex =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(email);
      },
      handleAddCSVStudents: async function (rows) {

        this.isAddingStudents = true;

        if (this.getProfile.is_paid === false && this.studentsFiltered.length >= 50) {
          EventBus.$emit('createToast', { type: 'Error', message: "You can't invite more than a 30 students because you don't have a premium account", time: 5000 });
          return;
        }

        if (!rows || !rows.length) return;

        const students = [];
        const fields = rows[0].split(',').map(f => f.trim());
        const expected = Object.keys(this.student_object);

        if (!this.arraysEqual(fields, expected)) {
          EventBus.$emit('createToast', { type: 'Error', message: 'You have errors on the fields. Please check the CSV Template.', time: 5000 });
          this.$refs.fileToUpload.value = '';
          return;
        }

        for (let i = 1; i < rows.length; i++) {
          const values = rows[i].split(',').map(v => v.trim());
          const student = {};
          fields.forEach((key, j) => {
            const val = values[j] || '';
            student[key] = j === 0 ? val : val.toLowerCase();
          });

          const name = student.name.trim();
          const email = student.email.trim().toLowerCase();
          if (name && this.isAnEmail(email)) {
            students.push(student);
          }
        }

        if (!this.getProfile.is_paid && students.length > 30) {
          EventBus.$emit('createToast', { type: 'Error', message: 'Free accounts can import up to 50 students per upload.', time: 5000 });
          this.$refs.fileToUpload.value = '';
          return;
        }

        try {
          const added = await this.$store.dispatch('addStudentToCourseCSV', {
            id: this.$route.params.courseID,
            array: students
          });
          this.$refs.fileToUpload.value = '';

          if (added && added.length) {
            const count = added.length;
            EventBus.$emit('createToast', { type: 'Success', message: `${count} ${count > 1 ? 'Students' : 'Student'} successfully added in your Course.`, time: 5000 });
            this.$store.dispatch('fetchCourseDetails', this.$route.params.courseID);
          }

          this.isAddingStudents = false;
        } catch (err) {
          this.isAddingStudents = false;
          this.$refs.fileToUpload.value = '';
          EventBus.$emit('createToast', { type: 'Error', message: 'Array without valid users to import.', time: 5000 });
          console.error(err);
        }
      },
      /* handleAddCSVStudents: async function (rows) {
        let array = [];

        let fields = rows[0].split(',').map((field) => {
          return field.trim();
        });

        let student_fields = Object.keys(this.student_object);
        if (!this.arraysEqual(fields, student_fields)) {
          const toast = { type: 'Error', message: 'You have errors on the fields. Please check the CSV Template.', time: 5000 };
          EventBus.$emit('createToast', toast);
          this.$refs.fileToUpload.value = '';
          return;
        }

        for (let index = 1; index < rows.length; index += 1) {
          let row = rows[index].split(',').map((row) => {
            return row.trim();
          });
          let student = {};
          student[fields[0]] = row[0];
          for (let j = 1; j < fields.length; j += 1) {
            if (row[j]) {
              student[fields[j]] = row[j].toLowerCase();
            }
          }
          if (student.name && student.name.trim() !== '' && student.email && this.isAnEmail(student.email.toLowerCase().trim())) {
            array.push(student);
          }
        }
        await this.$store.dispatch('addStudentToCourseCSV', { id: this.$route.params.courseID, array }).then((data) => {
          this.$refs.fileToUpload.value = '';
          if (data.length) {
            const toast = {
              type: 'Success',
              message: `${data.length} ${
                data.length > 1 ? 'Students' : 'Student'
              } successfully added in your Course.`,
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
            this.$store.dispatch(
              'fetchCourseDetails',
              this.$route.params.courseID
            );
          }
        }).catch((err) => {
          this.$refs.fileToUpload.value = '';
          const toast = { type: 'Error', message: 'Array without valid users to import.', time: 5000 };
          EventBus.$emit('createToast', toast);
          console.error(err);
        });
      }, */
    },
  });
</script>
<style scoped>
  input[type='checkbox'] {
    margin-top: 4px;
    width: 1.25rem !important;
    height: 1.25rem !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    box-shadow: none;
    font-size: 0.8rem;
    text-align: center;
    line-height: 1.25rem;
    border-radius: 0.25rem;
    border-color: gainsboro;
    --tw-bg-opacity: 1;
    background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
  }
  input[type='checkbox']:checked {
    background-color: #72CCD7;
    margin-bottom: 5px;
    margin-top: 4px;
    border-color: #72CCD7;
  }
  input[type='checkbox']:checked::after {
    font-family: 'Font Awesome 5 Free';
    content: '\f00c';
    font-weight: 900;
    color: white;
    line-height: 1.25rem;
  }

  .loader,
  .loader:after {
    border-radius: 50%;
    width: 16px;
    height: 16px;
    margin-left: -0.6px;
    margin-top: -1px;
  }
  .loader {
    border-top: 3px solid rgba(255, 255, 255, 0.2);
    border-right: 3px solid rgba(255, 255, 255, 0.2);
    border-bottom: 3px solid rgba(255, 255, 255, 0.2);
    border-left: 3px solid #ffffff;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 1.1s infinite linear;
  }
  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// ParticipantsTable.vue?6177201b